import { render, staticRenderFns } from "./AppLogoWrapper.vue?vue&type=template&id=20c0ca1c&scoped=true&"
import script from "./AppLogoWrapper.vue?vue&type=script&lang=js&"
export * from "./AppLogoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0ca1c",
  null
  
)

export default component.exports